import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  return (
    <footer className="footer" data-testid="footer">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="pt-14 pb-10 flex flex-col md:flex-row items-start justify-between gap-10">
          {/* Brand */}
          <div className="max-w-sm">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/cexus-logo.png"
                alt="CEXUS"
                className="w-8 h-8 object-contain"
                style={{ filter: 'brightness(2)' }}
              />
              <span
                className="text-sm font-semibold tracking-[0.15em] font-['Syne']"
                style={{
                  background: 'linear-gradient(135deg, #ffffff 30%, #afa283)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                CEXUS
              </span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed">
              {t('footerTagline')}
            </p>
          </div>

          {/* Ecosystem */}
          <div>
            <h4 className="text-white text-xs font-semibold tracking-[0.1em] uppercase mb-4">
              {t('footerEcosystem')}
            </h4>
            <nav className="flex flex-col gap-3">
              <a
                href="https://bituprosolution.ca"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
                data-testid="footer-bitupros"
              >
                BituPros Solutions
              </a>
              <a
                href="https://designermarket.ca"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
                data-testid="footer-designermarket"
              >
                Designer Market
              </a>
              <a
                href="https://streetzindeed.com"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
                data-testid="footer-streetz"
              >
                Streetz Indeed
              </a>
              <a
                href="https://alturaliving.ca"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
                data-testid="footer-altura"
              >
                Altura Living
              </a>
            </nav>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white text-xs font-semibold tracking-[0.1em] uppercase mb-4">
              {t('footerLegal')}
            </h4>
            <nav className="flex flex-col gap-3">
              <Link to="/faq" className="footer-link" data-testid="footer-faq">
                {t('footerFaq')}
              </Link>
              <Link to="/privacy" className="footer-link" data-testid="footer-privacy">
                {t('footerPrivacy')}
              </Link>
              <Link to="/terms" className="footer-link" data-testid="footer-terms">
                {t('footerTerms')}
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white text-xs font-semibold tracking-[0.1em] uppercase mb-4">
              {t('contact')}
            </h4>
            <a
              href="mailto:Casper@cexus.ca"
              className="footer-link hover:text-white"
              data-testid="footer-email"
            >
              Casper@cexus.ca
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-xs">
            &copy; {currentYear} CEXUS. {t('footerRights')}
          </p>
          <p className="text-gray-600 text-xs">
            {t('footerFoundedBy')}{' '}
            <a
              href="https://www.instagram.com/casperthe6ix?igsh=a3A4YTEyNDBycTlk&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors"
              data-testid="founder-link"
            >
              Casper
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
